import React from 'react';
import { StarsBackground } from './stars';

interface SectionWithStarsProps {
  children: React.ReactNode;
  sectionId?: string;
  style?: React.CSSProperties;
}

const SectionWithStars: React.FC<SectionWithStarsProps> = ({ children, sectionId, style }) => {
  const defaultStyle: React.CSSProperties = {
    padding: '80px 16px',
    position: 'relative',
    overflow: 'hidden'
  };

  const combinedStyles = { ...defaultStyle, ...style };

  return (
    <section id={sectionId} style={combinedStyles}>
      <StarsBackground>
        {children}
      </StarsBackground>
    </section>
  );
};

export default SectionWithStars; 